<template>
  <div>
      <Header></Header>
      <ProblemsTable />
  </div>
</template>

<script>
import Header from "@/components/header.vue";
import ProblemsTable from "@/components/production-planning/ProblemsTable.vue";
export default {
    components: {
        Header,
        ProblemsTable
    }
}
</script>

<style>

</style>